export const headers = [
  { name: 'Familia', field: 'parentProductCategory.name', sortable: true },
  { name: 'Nome', field: 'name', sortable: true },
  { name: 'Ações', field: 'actions', sortable: false }
]
